<vectronic-card [title]="title" [displayClose]="true" (closed)="dialogRef.close()">
  <div class="schedule-modal" body>
    <rc-schedule-view
      [selectedCollarIds]="data.selectedCollarIds"
      [showSubmit]="false"
      [showClear]="false"
      [readonly]="true"
      [videoFormatsOptions]="videoFormatsOptions$ | async"
      [photoFormatsOptions]="photoFormatsOptions$ | async"
      [defaultVirtualFenceConstructionRules]="getDefaultVirtualFenceConstructionRules()"
      [isAdmin]="data.isAdmin"
      [permanentEndDate]="permanentEndDate$ | async"
    ></rc-schedule-view>
  </div>
</vectronic-card>
